import React from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PdfCompany from '../pdf/companySchedule';
import PdfAllCompany from '../pdf/allCompanySchedule';
import PdfAllInvestors from '../pdf/allInvestorsSchedule';
import PdfInvestor from '../pdf/investorSchedule';
import GetEvent from '../../services/getEvent';
import GetCompanies from '../../services/getCompanies';
import GetInvestors from '../../services/getInvestors';
import GetIntermediary from '../../services/getIntermediary';
import GetMeetings from '../../services/getMeetings';
import Cookies from 'universal-cookie';
import GetCompaniesExcel from '../../services/getCompaniesExcel';
import Constants from "../consts";
import moment from 'moment';

export default async function generateCompanyExcel(){

    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    const scheduleSubject = cookies.get('scheduleSubject', { path: '/' });

    var event = await GetEvent(uname, token, currentEventId);

    var companies = await GetCompanies(uname, token, currentEventId);
    var investors = await GetInvestors(uname, token, currentEventId);
    var intermediary = await GetIntermediary(uname, token, scheduleSubject);
    var meetings = await GetMeetings(uname, token, currentEventId);

    var startDate = moment(event.startDate, "DD/MM/yyyy");
    var endDate = moment(event.endDate, "DD/MM/yyyy");


    var eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }

    var filterMeetings = meetings;
    var infoSchedules = event.brokersInfoSchedulesCompaniesEnabled;

    var jsonTabs = [];

    eventDays.map(v => {
        
      var jsonData = [];

      let date = moment(v).format('DD/MM/yyyy');
      let dateComplete = moment(v).format('dddd, DD MMMM yyyy');

      jsonData.push(['<b>Schedule for ' + intermediary.name + ' - ' + dateComplete + '</b>']);
      
      let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
      filterMeetingsDate = filterMeetingsDate.filter((elem) => elem.brokerInvestorId == intermediary.id);

      let sortMeetings = filterMeetingsDate.sort((a, b) => {
          var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
          var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

          return time1 - time2;
      });

      if (sortMeetings.length <= 0) return null;

      sortMeetings.map(m => {
                  let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                  let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');

                  let strTime = moment(meetingTime).format("HH:mm");
                  let strEndTime = moment(meetingEndTime).format("HH:mm");

                  var companiesList = [];
                  m.investors.map(inv => {
                      if (companiesList.indexOf(inv.company) == -1)
                          companiesList.push(inv.company);
                  });

                  var meetingDesc = '<b>' + m.i_company + '</b> - ' + m.i_name + ' meets <b>' + m.c_name + '</b>';

                  jsonData.push([strTime + ' - ' + strEndTime, meetingDesc]);
              }) 

              jsonTabs.push({
                name: dateComplete,
                data: jsonData
              });

            });

    var json = {
      tabs : jsonTabs
    };

    await GetCompaniesExcel(uname, token, JSON.stringify(json), intermediary.name);
    window.location.href= Constants.mainUrl+'apis/files/'+ intermediary.name +'.xlsx';

}